import React, { useState } from "react";
import { logo } from "../../../assets";
import MeetingView from "./MeetingView";
import { useClassRoom } from "../../../Hooks/ClassRoom";
import { SIDEBAR_WIDTH } from "../../../utils/layoutUtils";

const DraggableBox = () => {
  const [boxType, setBoxType] = useState("BOX"); // Types: BOX, CIRCLE, FULL
  const [position, setPosition] = useState({ x: SIDEBAR_WIDTH, y: 0 });
  const { lastCallID, callUser } = useClassRoom();

  const handleMouseDown = (e) => {
    const offsetX = e.clientX - position.x;
    const offsetY = e.clientY - position.y;

    const handleMouseMove = (e) => {
      setPosition({
        x: e.clientX - offsetX,
        y: e.clientY - offsetY,
      });
    };

    const handleMouseUp = () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  const isDraggable = boxType === "BOX";
  const isCircle = boxType === "CIRCLE";
  const isFull = boxType === "FULL";
  const isMobile = window.screen.width < 768;

  return (
    <div
      className={`draggable-container ${
        isDraggable
          ? "draggable-box"
          : isCircle
          ? "circle-box"
          : "full-call-box"
      }`}
      style={{
        left: isFull
          ? 0
          : isMobile
          ? 5
          : isCircle
          ? SIDEBAR_WIDTH + 50
          : position.x,
        top: isFull ? 0 : isMobile ? 60 : isCircle ? 7 : position.y,
        position: "fixed",
      }}
      onMouseDown={isDraggable ? handleMouseDown : undefined}
      onClick={isCircle ? () => setBoxType("BOX") : undefined}
    >
      {lastCallID || callUser ? (
        <MeetingView setBoxType={setBoxType} boxType={boxType} />
      ) : (
        <div className="image-box">
          <img src={logo} alt="Logo" loading="lazy" decoding="async" />
        </div>
      )}
    </div>
  );
};

export default DraggableBox;
